module.exports = __webpack_public_path__ + "img/product.ae5483b6.png";